// #568 — which kind of device a learner signed in on, from coarse signals only:
// whether the main pointer is a finger, and the viewport's shorter side. No
// user-agent string, nothing that tells one device from another of its kind.

/** 'phone' | 'tablet' | 'desktop'. Pure. */
export function classifyDevice({ coarse, shortSide }) {
  if (!coarse || !(shortSide > 0)) return 'desktop';
  if (shortSide < 600) return 'phone';
  if (shortSide < 1024) return 'tablet';
  return 'desktop';
}

export function deviceType() {
  try {
    const coarse = !!window.matchMedia?.('(pointer: coarse)')?.matches;
    const shortSide = Math.min(window.innerWidth || 0, window.innerHeight || 0);
    return classifyDevice({ coarse, shortSide });
  } catch {
    return 'desktop';
  }
}
